import { _, ts } from '_core';

import { replaceNans } from './helpers';

export const nestedBarChartFormat = (
  data: ts.types.widgets.TableData,
  category = 'history'
): ts.types.widgets.NestedBarWidgetData => {
  const countData: ts.types.widgets.CountData = {};
  const formattedData: ts.types.widgets.NestedBarData = [];

  data = replaceNans(data);
  data.forEach((item) => {
    const categoryValue = item[category];
    const categoryKey =
      _.isNumber(categoryValue) && !Number.isInteger(categoryValue)
        ? categoryValue.toFixed(2)
        : categoryValue.toString();

    if (item.type === 'count' || item.tab === 'count') {
      countData[categoryKey] = _.omit(item, [category, 'type', 'Unnamed: 0']);
    } else {
      formattedData.push({
        category: categoryKey,
        ..._.omit(item, [category, 'type', 'Unnamed: 0']),
      });
    }
  });

  return { data: formattedData, count: countData };
};
